import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import Head from "next/head";
import AppbarIndustry from "../../../../components/AppbarIndustry";
import HeroSection from "../../../../components/HeroSection";
import TitleIndustry from "../../../../components/TitleIndustry";
import HeroEnquiryFormIndustry from "../../../../components/HeroEnquiryFormIndustry";
import FooterIndustry from "../../../../components/FooterIndustry";
import { ourProducts } from "../../../../components/ocean-technology/data";
import StickyWhatsappIndustries from "../../../../components/StickyWhatsappIndustries";

function ManagementSystems() {
  const products = [
    
    "Coastal and Marine Environmental Monitoring Software",
    

  ];
  const data = {
    image: "/industries/ocean-technology/coastal-and-marine-environmental-monitoring-software.jpg", // Replace with the appropriate image URL for Environmental Monitoring
    intro: `Embark on a journey of environmental stewardship with our Coastal and Marine Environmental Monitoring Software. Harness the power of data to understand and protect our coastal and marine ecosystems.`,
    keyFeatures: [
        {
            title: "Real-time Environmental Data Collection",
            content: "Collect real-time environmental data to gain insights into the health and conditions of coastal and marine ecosystems.",
        },
        {
            title: "Ecosystem Health Assessment",
            content: "Assess the health of ecosystems through advanced analytics, providing a comprehensive understanding of environmental conditions.",
        },
        {
            title: "Early Warning Systems",
            content: "Implement early warning systems to detect and mitigate ecological risks, contributing to proactive environmental conservation.",
        },
    ],
    howItWorks: `Explore the integration of sensor networks and data analytics in monitoring coastal and marine environments. Learn how our software transforms data into actionable insights for environmental conservation.`,
    benefits: {
        title: "The benefits of Coastal and Marine Environmental Monitoring Software",
        data: [
            "Improved Environmental Conservation for Coastal and Marine Ecosystems.",
            "Enhanced Decision-Making for Coastal Management Initiatives.",
            "Mitigation of Ecological Risks Through Proactive Monitoring.",
        ],
    },
    industries: "Tailored for environmental agencies, coastal management authorities, and research institutions. Discover how our software supports diverse initiatives focused on environmental monitoring and conservation.",
    stories: `Read about successful environmental monitoring projects powered by our software. Learn how organizations have contributed to the preservation of coastal and marine ecosystems.`,
    contactUs: `Connect with our experts to discuss how our software can contribute to your environmental monitoring goals. Whether you're involved in conservation projects or coastal management, we have the solutions for you.`,
    futureDevelopments: `Stay informed about upcoming features and innovations in environmental monitoring technology. Witness the evolution of tools that redefine our ability to protect and preserve coastal and marine environments.`,
    technology: `Learn about the compatibility of our software with various sensors and environmental monitoring devices. See how our solution seamlessly integrates into existing environmental monitoring networks.`,
    support: `Access comprehensive training resources and ongoing support. Ensure that your team is well-equipped to utilize our software for effective environmental monitoring and conservation.`,
    industry: `Understand our commitment to industry standards and compliance in environmental monitoring. Trust in the accuracy and reliability of the data collected by our software.`,
    events: "Stay updated on events and collaborative opportunities in the field of environmental monitoring. Join us in contributing to the global efforts toward sustainable coastal and marine ecosystems.",
    blog: `Explore our blog and knowledge hub for articles, case studies, and expert insights on coastal and marine environmental monitoring.`,
    careers: `Discover exciting career opportunities in the field of environmental technology and conservation. Join us in making a positive impact on the health of coastal and marine ecosystems.`,
};

  

  
  
  
  const content = "Embark on an oceanic technology voyage with us! Whether you're navigating advancements in marine technology, underwater exploration, environmental monitoring, or any facet of ocean technology, we offer tailored solutions. Our expertise spans projects of various scales, ensuring our ocean technology solutions align seamlessly with your objectives, budget, and scope."
    return (
    <>
   <Head>
    <title>Coastal and Marine Environmental Monitoring Software | Safeguard Marine Ecosystems | Techbrain Networks</title>
    <meta name="description" content="Monitor and analyze coastal and marine ecosystems with Techbrain Networks Environmental Monitoring Software, providing real-time data for sustainable management." />
    <meta name="keywords" content="coastal environmental monitoring, marine ecosystem software, real-time environmental data, Techbrain Networks" />
    <meta property="og:title" content="Coastal and Marine Environmental Monitoring Software | Safeguard Marine Ecosystems | Techbrain Networks" />
    <meta property="og:description" content="Techbrain Networks Coastal and Marine Environmental Monitoring Software provides real-time insights into ecosystem health and environmental data." />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://www.techbrainnetworks.com/industries/ocean-technology/products/coastal-and-marine-environmental-monitoring-software" />
    <meta property="og:image" content="https://www.techbrainnetworks.com/logo-tbn.jpg" />
    <meta property="og:image:alt" content="Coastal and Marine Environmental Monitoring Software" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Coastal and Marine Environmental Monitoring Software | Safeguard Marine Ecosystems" />
    <meta name="twitter:description" content="Monitor marine ecosystems with Techbrain Networks Environmental Monitoring Software, providing real-time data and insights for ecosystem management." />
     <meta name="twitter:image" content="https://www.techbrainnetworks.com/logo-tbn.jpgg" />
    <link rel="canonical" href="https://www.techbrainnetworks.com/industries/ocean-technology/products/coastal-and-marine-environmental-monitoring-software" />
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Coastal and Marine Environmental Monitoring Software",
        "image": "https://www.techbrainnetworks.com/logo-tbn.jpg",
        "description": "Techbrain Networks Coastal and Marine Environmental Monitoring Software provides real-time data and insights for monitoring and managing marine ecosystems.",
        "brand": "Techbrain Networks",
        "offers": {
            "@type": "Offer",
            "url": "https://www.techbrainnetworks.com/industries/ocean-technology/products/coastal-and-marine-environmental-monitoring-software",
            "priceCurrency": "USD",
            "price": "Contact for pricing"
        }
    })}} />
                     <link rel="icon" href="/favicon.png" />

</Head>
<StickyWhatsappIndustries link={"https://api.whatsapp.com/send?phone=918754906714"}  color={"#ED8D8D"} />

      <AppbarIndustry title={"Ocean and Technology"} homeLink={'/industries/ocean-technology'} link={'/industries/ocean-technology/products'} />
      <HeroSection img={"/industries/ocean-technology/coastal-and-marine-environmental-monitoring-software.jpg"}>Coastal and Marine Environmental Monitoring Software</HeroSection>
      <Box
        sx={{
          px: [0, "1.2rem", "3.8rem", "3rem"],
          pb: [1, 1, 2, 2, 4],
          bgcolor: "#080707",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {/* intro */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",

            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}>Introduction</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.intro}
          </Typography>
        </Box>
        {/* Key Features Unleashed */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", ".5rem", "1.5rem", "1.5rem", "1rem"],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}>Key Features Unleashed</TitleIndustry>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: ["column", "row"],
              flexWrap: "wrap",
              justifyContent: [null, "space-between", "flex-start"],
              gap: ["2rem", "1rem", "2rem", "2rem", "2rem"],
            }}
          >
            {data.keyFeatures.map((i, k) => (
              <Box
                sx={{
                  display: "flex",
                  width: ["95%", "45%", "30%"],
                  flexDirection: "column",
                  gap: ["0.5rem", "0.5rem", "0.5rem", "0.5rem", "1rem"],
                }}
              >
                <Typography
                  sx={{
                    fontSize: [
                      "1.3rem",
                      "1.2rem",
                      "1.2rem",
                      "1.4rem",
                      "1.5rem",
                    ],
                    fontWeight: "bold",
                    color: "#ED8D8D",
                  }}
                >
                  {i.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {i.content}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
        {/* how it works */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}>How It Works?</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.howItWorks}
          </Typography>
        </Box>
        {/* benefits */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", "1.5rem", ".5rem"],
          }}
        >
          <Stack
            direction={"column"}
            sx={{
              width: ["100%", "48%"],
            }}
          >
            <TitleIndustry color={"#ED8D8D"}>Benefits</TitleIndustry>
            <Typography
              sx={{
                fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                color: "#fff",
              }}
            >
              {data.benefits.title}:
            </Typography>

            <Stack
              direction={"column"}
              sx={{
                gap: [1, 1, 2],
                mt: [3, 3, 4],
              }}
            >
              {data.benefits.data.map((i, k) => (
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {"•  "}
                  {i}
                </Typography>
              ))}
            </Stack>
          </Stack>

          <Box
            sx={{
              width: ["100%", "50%", "45%"],
              height: ["20rem", "20rem", "20rem", "25rem", "30rem"],
              backgroundImage: `url(${data.image})`,
              backgroundposition: "center",
              backgroundSize: "cover",
              backgroundrepeat: "no-repeat",
              borderRadius: "16px",
            }}
          />
        </Stack>
        {/* Industries */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}>Industries</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industries}
          </Typography>
        </Box>

          

        {/* Future Developments and Innovations*/}
 
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}>Future Developments and Innovations</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
           Stay informed about upcoming features and innovations in biometric security and identity management technology.
          </Typography>
        </Box>

        {/* Technology Integration */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}>Technology Integration</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.technology}
          </Typography>
        </Box>

        {/* User Training and Support */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}>User Training and Support</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.support}
          </Typography>
        </Box>

        {/*  Industry Standards and Compliance */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}> Industry Standards and Compliance</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industry}
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
          
            display: "flex",
            gap: "1rem",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: ["2rem", "3rem", "3rem", "4rem"],
                fontWeight: "bold",
                color: "#ED8D8D",
                textAlign: "center",
              }}
            >
              Contact
            </Typography>
          </Box>
        <Box
            sx={{
              width: [ "100%"],
              display: "flex",
              justifyContent: "center",
              padding:'1rem'
            }}
          >
            <HeroEnquiryFormIndustry color={"#ED8D8D"} products={products} content={content}/>
          </Box>
        </Box>
      </Box>
      
      <FooterIndustry ourProducts={ourProducts} color={"#ED8D8D"} bg={"#080707"} />
    </>
  );
}

export default ManagementSystems
;
